import { DateTime } from 'luxon';
import { useTranslation } from 'react-i18next';

/**
 * Custom hook to validate a meter row and return a list of warnings.
 * @returns {(meterRow: Object) => Array<{ key: string, value: string }>}
 */
function useValidateMeterRow() {
  const { t } = useTranslation('portfolio-analysis');

  return function validateMeterRow(meterRow) {
    const warnings = [];

    if (meterRow.data_end_time) {
      const daysSince =
        DateTime.fromISO(meterRow.data_end_time).diffNow('days').days * -1;
      if (daysSince > 14) {
        warnings.push({
          key: 'data_end_time',
          value: t('warnings.dataOutdated', {
            lastDataTimestamp: DateTime.fromISO(
              meterRow.data_end_time,
            ).toFormat('dd-MM-yyyy'),
          }),
        });
      }
    }

    if (
      typeof meterRow.one_year_data_pct === 'number' &&
      meterRow.thirty_day_data_pct < 0.8
    ) {
      warnings.push({
        key: 'thirty_day_data_pct',
        value: t('warnings.dataLowLast30Days', { threshold: '80%' }),
      });
    }

    if (
      typeof meterRow.one_year_data_pct === 'number' &&
      meterRow.one_year_data_pct < 0.8
    ) {
      warnings.push({
        key: 'one_year_data_pct',
        value: t('warnings.dataLowLast1Year', { threshold: '80%' }),
      });
    }

    if (
      typeof meterRow.two_year_data_pct === 'number' &&
      meterRow.two_year_data_pct < 0.8
    ) {
      warnings.push({
        key: 'two_year_data_pct',
        value: t('warnings.dataLowLast2Years', { threshold: '80%' }),
      });
    }

    if (
      typeof meterRow.three_year_data_pct === 'number' &&
      meterRow.three_year_data_pct < 0.8
    ) {
      warnings.push({
        key: 'three_year_data_pct',
        value: t('warnings.dataLowLast3Years', { threshold: '80%' }),
      });
    }

    return warnings;
  };
}

export default useValidateMeterRow;
